/**
 * The workspace items the session designer offers for a pool ("Use items in
 * the platform", "From a collection").
 *
 * A retired item has left every list — `retire_new_item` (mig 746) sets its
 * exit_status to archived and keeps the record — so it is never offered.
 */

import { itemExitStatus } from '../../lib/intakeQueueVisibility';
import type { PlatformItem } from './components/ItemInputModal';

export function offeredPlatformItems(
  items: ReadonlyArray<{ id: string; title: string; exit_status?: string; exitStatus?: string }>,
): PlatformItem[] {
  return items
    .filter((i) => itemExitStatus(i) !== 'archived')
    .map((i) => ({ id: i.id, title: i.title }));
}
